/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/
  
import { FunctionComponent, VNode } from 'preact';
import { HTMLAttributes } from 'preact/compat';
import { classes, VComponent } from '@adobe-commerce/elsie/lib';
import '@/cart/components/CartSummaryTable/Elements/Item/Item.css';

export interface ItemProps extends HTMLAttributes<HTMLDivElement> {
  productTitle: VNode;
  sku?: VNode;
  image?: VNode;
  configurations?: VNode;
  alert?: VNode;
  warning?: VNode;
}

export const Item: FunctionComponent<ItemProps> = ({
  className,
  productTitle,
  sku,
  image,
  configurations,
  alert,
  warning,
  ...props
}) => {
  return (
    <div {...props} className={classes(['cart-cart-summary-table__item', className])}>
      {image && <VComponent className="cart-cart-summary-table__item-image-wrapper" node={image} />}
      <div className="cart-cart-summary-table__item-details">
        {productTitle && <VComponent className="cart-cart-summary-table__item-name" node={productTitle} />}
        {sku && <VComponent className="cart-cart-summary-table__sku" node={sku} />}
        {alert && <VComponent className="cart-cart-summary-table__item-quantity-alert-text" node={alert} />}
        {warning && <VComponent className="cart-cart-summary-table__item-quantity-warning-text" node={warning} />}
        {configurations && <VComponent className="cart-cart-summary-table__item-configurations" node={configurations} />}
      </div>
    </div>
  );
};
